import React from "react";
import { useResponse } from "screens/question/hooks";

import {
  Container,
  StyledTouchableOpacity,
  GenderImage,
  GenderText,
} from "./styled";

export const LabeledImageQuestion = ({ question }) => {
  const { options, selectedOptions, selectOption } = useResponse(question);
  return (
    <Container>
      {options.map(option => {
        const isSelected = selectedOptions[option.virtual_id];
        const gender = getGender(option.text);
        return (
          <StyledTouchableOpacity
            key={option.id}
            $gender={gender}
            $isSelected={isSelected}
            onPress={() => selectOption(option)}
          >
            <GenderImage
              gender
              $isSelected={isSelected}
              source={{ uri: option.image }}
            />
            <GenderText $isSelected={isSelected}>{option.text}</GenderText>
          </StyledTouchableOpacity>
        );
      })}
    </Container>
  );
};

const getGender = text => {
  if (text.match(/female/i)) {
    return "F";
  }
  if (text.match(/male/i)) {
    return "M";
  }
};
